const positions = [
	{
		name: 'La levrette',
		feminine: true,
		description: `[La position préférée des Français·es !](https://lepointq.com/articles/20-10/la-levrette-la-position-preferee-des-francais.e.s/) Une personne à quatre pattes, l’autre derrière...`
	},
	{
		name: 'Le missionnaire',
		description: `La classique des classiques ! L’un·e sur le dos, l’autre au-dessus, les yeux dans les yeux...`
	},
	{
		name: 'Le 69',
		description: `L’un·e sur l’autre (ou l’inverse), la tête vers vos sexes respectifs...`
	},
	{
		name: 'L’andromaque',
		feminine: true,
		description: `Les femmes prennent le pouvoir ! Rendez-vous au-dessus de votre partenaire, allongé·e sur le dos...`
	},
	{
		name: 'Le latéral',
		description: `Place à la géométrie ! Angle droit, aigu ou obtus, peut importe, tant que l’un·e est sur le côté, et l’autre face à ellui...`
	},
	{
		name: 'Les ciseaux',
		plural: true,
		description: `Les jambes se croisent, comme des paires de ciseaux emboîtées...`
	},
	{
		name: 'Le Y',
		description: `Comme l’expression bien connue ! Sur le bord du lit, l’un·e penché·e vers le bas, l’autre vers le haut...`
	},
	{
		name: 'Le cheval infernal',
		description: `Comme l’andromaque, mais les fesses tournées vers la personne en dessous. Préparez-vous pour une course de l’enfer...`
	},
	{
		name: 'Le facesitting',
		description: `Le sexe sur le visage de l’autre, pour tout contrôler...`
	},
	{
		name: 'La brouette',
		feminine: true,
		description: `Pour une fois, le nom est imagé ! Allez, on part à la récolte...`
	},
	{
		name: 'L’ondulation',
		feminine: true,
		description: `Cette position pourrait rappeler un étrange film : vous êtes à quatre pattes, la tête vers les fesses de votre partenaire...`
	},
	{
		name: 'Le Nirvana',
		description: `Comme le missionnaire, sauf que la personne en dessous a les jambes serrées. On monte au 7e ciel...`
	},
	{
		name: 'L’amazone',
		feminine: true,
		description: `Une position de reine ! L’un·e au-dessus de l’autre, assis sur une chaise...`
	
	},
	{
		name: 'L’union de\nl’éléphante',
		feminine: true,
		description: `Les partenaires à genoux, face à face et le corps tendu...`
	},
	{
		name: 'La pieuvre',
		feminine: true,
		description: `On fait travailler sa souplesse ! Comme un missionnaire, avec une jambe sur l'épaule...`
	},
	{
		name: 'Le cocktail',
		description: `Debout, face à face, tout simplement...`
	},
	{
		name: 'Le petit pont',
		description: `Vous vous souvenez des cours d'accrosport ? Et bien c'est la même chose : l’un·e fait un pont en arrière, et l'autre se met au-dessus...`
	},
	{
		name: 'La cuillère',
		feminine: true,
		description: `Comme un câlin, l’un·e dans les bras de l’autre, allongé·e·s sur le côté...`
	},
	{
		name: 'Le cadenas',
		description: `Comme un missionnaire, sauf qu’une personne est assise sur un meuble (il paraît que c’est encore mieux sur une machine à laver en marche)...`
	},
	{
		name: 'Le cunnilingus',
		description: `Vous le connaissez sûrement bien ! Réservé aux personnes de goût...`
	},
	{
		name: 'L’union\nde l’aigle',
		feminine: true,
		description: `Ne vous en faites pas, il ne s’agit pas d’apprendre à voler ! Vous êtes simplement allongé·e·s face à face, sur le côté de votre corps...`

	},
	{
		name: 'L’équilibriste',
		description: `C’est parti pour un spectacle de cirque ! L’un·e soulève les jambes et la taille de l’autre, qui s’appuie sur un bras...`
	},
	{
		name: 'La fellation',
		feminine: true,
		description: `Ah, le sexe oral, c’est quand même pas mal... [Et vous êtes assez d’accord !](https://lepointq.com/articles/20-11/et-toi-le-sexe-oral/) Mais pour pimper un peu tout ça, on vous propose une fellation...`
	},
	{
		name: 'L’étoile de mer',
		feminine: true,
		description: `Accroché·e·s sur votre rocher, le but est de ne pas bouger...`
	},
	{
		name: 'Le président\nvigoureux',
		description: `Toujours plus haut ! L’un·e les pieds sur un meuble, dos à son ou sa partenaire qui le ou la soulève par les fesses...`
	},
	{
		name: 'La liane',
		feminine: true,
		description: `Tout est dans l’échauffement ! Debout face à face, l’un·e lève la jambe pour la poser sur l’épaule de l’autre...`
	},
	{
		name: 'La montagne\nmagique',
		feminine: true,
		description: `Comme la levrette, en s’appuyant sur une pile de coussins pour pouvoir s’allonger l’un·e sur l’autre...`
	},
	{
		name: 'Le nœud coulant',
		description: `Face à face, assis·e·s sur les fesses, les jambes entremêlées...`
	},
	{
		name: 'L’anulingus',
		description: `[Un plaisir tabou](https://lepointq.com/articles/20-11/anulingus-vous-avez-dit-tabou/) que tout le monde peut pratiquer...`
	}
];

const variants = [
	{
		name: 'aquatique',
		description: `mais dans l’eau (ou sous l’eau, si vous êtes bon·ne·s en apnée...) ! [Attention à l’effet ventouse !](https://lepointq.com/articles/21-07/l-amour-au-creux-des-vagues-est-ce-une-bonne-idee/)`
	},
	{
		name: 'fruité',
		feminine: 'fruitée',
		plural: 'fruités',
		description: `mais façon salade de fruits : banane, fraise, mangue, ou carrément pastèque ? Vous allez vous régaler, [bande de gourmand·e·s !](https://lepointq.com/articles/21-05/plaisirs-gourmands/)`
	},
	{
		name: 'chocolaté',
		feminine: 'chocolatée',
		plural: 'chocolatés',
		description: `mais on y ajoute une touche de cacao : en carrés ou fondu, comment le dégusterez-vous ?`
	},
	{
		name: 'à trois ou plus',
		description: `mais avec des copain·ine·s, ou de parfait·e·s inconnu·e·s ! À vous de voir comment vous vous organisez. [Et pour vous, c’est un fantasme ?](https://lepointq.com/articles/21-03/le-plan-a-trois-a-t-il-vraiment-la-cote/)`
	},
	{
		name: 'contre un mur',
		description: `mais on y introduit un peu de verticalité. Vos jambes (ou vos bras) pourront-ils vous porter ?`
	},
	{
		name: 'les yeux bandés',
		description: `mais sans pouvoir utiliser ses yeux. Si ce n’est pas sensuel ça...`
	},
	{
		name: 'suspendu',
		feminine: 'suspendue',
		plural: 'suspendus',
		description: `mais au-dessus du sol. De quoi se faire tourner la tête !`
	},
	{
		name: 'attaché',
		feminine: 'attachée',
		plural: 'attachés',
		description: `mais pieds et poings liés, à la merci de votre partenaire. [Les quatre lettres "BDSM" vous intriguent ?](https://lepointq.com/articles/21-04/tout-sur-le-bdsm-avec-la-sexologue-claire-alquier/)`
	},
	{
		name: 'déguisé',
		feminine: 'déguisée',
		plural: 'déguisés',
		description: `mais avec des costumes ! Infirmière, pompier, [héros·ïne de jeu vidéo](https://lepointq.com/articles/21-02/du-sexe-dans-les-jeux-video/) ou de dessin animé, à vous d’imaginer de nouvelles aventures !`
	},
	{
		name: 'claqué',
		feminine: 'claquée',
		plural: 'claqués',
		description: `mais on se permet des gestes un peu plus marquants ! Attention, on pose ses limites respectives avant de commencer !`
	},
	{
		name: 'en musique',
		description: `mais avec [une playlist dédiée](https://lepointq.com/articles/21-02/du-love-dans-tes-oreilles/) ! Alors, on part sur du classique, du rock, ou de la variété française pour danser sous la couette ?`
	},
	{
		name: 'à la cire chaude',
		description: `mais avec des gouttes de cire chaude qui tombent sur vos corps. Ambiance extra caliente garantie !`
	},
	{
		name: 'on the rocks',
		description: `mais avec des glaçons, pour frissonner toujours plus de plaisir… Attention aux brûlures !`
	},
	{
		name: 'dirty talké',
		feminine: 'dirty talkée',
		plural: 'dirty talkés',
		description: `mais avec des mots crus, qui l’eût cru ?`
	},
	{
		name: 'à la va-vite',
		description: `mais en coup de vent, parce que vous êtes pressé·e·s. Ne vous faites pas attraper !`
	},
	{
		name: 'avec un sextoy',
		description: `mais on rajoute Gégé dans l’équation, pour [toujours plus de possibilités](https://lepointq.com/articles/20-11/tous-ces-beaux-joujoux-que-je-vois-en-reve/) !`
	},
	{
		name: 'porté',
		feminine: 'portée',
		plural: 'portés',
		description: `mais on fait travailler les muscles ! N’hésitez pas à vous servir d’un meuble pour rendre la tâche plus facile.`
	},
	{
		name: 'non pénétratif',
		feminine: 'non pénétrative',
		plural: 'non pénétratifs',
		description: `mais sans pénétration ! Pas forcément facile, n’est-ce pas ? Allez, faites marcher vos méninges ! [Besoin de quelques conseils ?](https://lepointq.com/articles/20-11/un-rapport-sexuel-se-termine-forcement-par-une-penetration/)`
	},
	{
		name: 'avec Rocco',
		description: `mais devant une vidéo porno ou [du porno audio](https://lepointq.com/articles/20-10/le-porno-audio-je-crie-ouuuui/) ! Peut-être l’occasion de faire passer un message ?`
	},
	{
		name: 'silencieux',
		feminine: 'silencieuse',
		description: `mais sans un bruit ! Saurez-vous résister au son du plaisir qui monte ?`
	},
	{
		name: 'sextapé',
		feminine: 'sextapée',
		plural: 'sextapés',
		description: `mais vous êtes filmé·e·s ! Attention, la vidéo reste entre vous : en France, [le revenge porn est puni par la loi](https://lepointq.com/articles/20-12/le-revenge-porn-en-france-comment-s-en-proteger/)...`
	}
];

const buttonTexts = [
	'Une autre ?',
	'Une autre ?',
	'Une autre ?',
	'Une autre ?',
	'Une autre ?',
	'Pas convaincu·e·s ?',
	'Pas convaincu·e·s ?',
	'Pas convaincu·e·s ?',
	'Quelque chose de différent ?',
	'Quelque chose de différent ?',
	'Trop compliqué ?',
	'Trop compliqué ?',
	'Pas à votre goût ?',
	'Pas à votre goût ?',
	'Un peu trop technique ?',
	'Un peu trop technique ?',
	'Peur du claquage ?'
];


export {
	positions,
	variants,
	buttonTexts
};